import Vue from "vue";
import ElementUI from "element-ui";
import App from "./App.vue";
import router from "@/router";
import store from "@/store";
import { deepClone, getDataList, getTableConfig } from "@/utils";
import globalLoading from "@/utils/loading";
import "@/permission.js";
import mix from "@/utils/mix";
import "@/utils/components";
import * as dayjs from "dayjs";
import "@/style/tailwind.css";

// import "default-passive-events";
//md5加密
import md5 from "js-md5";
import "@/style/element-variables.scss";
import "@/style/animation.css";
import "@/style/iconfont.css";
import "@/style/font.css";
import Print from "vue-print-nb";
// e-icon-picker添加iconfont图标
// import { analyzingIconForIconfont } from "e-icon-picker";
// import "@/style/font/iconfont.css";
// import iconfont from "@/style/font/iconfont.json";
// let forIconfont = analyzingIconForIconfont(iconfont);
// vue-treeSelect样式
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import Treeselect from "@riophae/vue-treeselect";
Vue.component("TreeSelect", Treeselect);
Vue.mixin(mix);
Vue.use(ElementUI, {
  size: "small",
});
Vue.use(Print);
// Vue.use(eIconPicker, {
//   FontAwesome: true,
//   ElementUI: true,
//   addIconList: forIconfont.list,
//   removeIconList: [],
//   zIndex: 3100,
// });
// 深拷贝
Vue.prototype.$deepClone = deepClone;
// 加载
Vue.prototype.$globalLoading = globalLoading;
// md5加密
Vue.prototype.$md5 = md5;
// 定制化表单获取自定义表单接口方法
Vue.prototype.$getDynomicList = getDataList;
// 定制化表单获取自定义表单配置方法
Vue.prototype.$getTableConfig = getTableConfig;
// 时间
Vue.prototype.$dayjs = dayjs;
Vue.config.productionTip = false;

// 时间格式化函数
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

new Vue({
  router,
  store,
  beforeCreate() {
    Vue.prototype.$bus = this;
  },
  render: (h) => h(App),
}).$mount("#app");
